import { createRealGetRequest } from ".";
import { paths } from "../itemsbycategory.types";

export const realGetItemsByCategoryId = createRealGetRequest<
  paths["/exp/v1/dna/categories/getItemByCategoryId"]
>("/category/getItemByCategoryId");
